"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = __importDefault(require("./recover/actions"));
var app_texts_1 = __importDefault(require("./recover/app_texts"));
var auth_1 = __importDefault(require("./recover/auth"));
var companies_1 = __importDefault(require("./recover/companies"));
var debt_status_counts_1 = __importDefault(require("./recover/debt_status_counts"));
var debtors_1 = __importDefault(require("./recover/debtors"));
var debts_1 = __importDefault(require("./recover/debts"));
var demand_templates_1 = __importDefault(require("./recover/demand_templates"));
var demands_1 = __importDefault(require("./recover/demands"));
var helpers_1 = require("./recover/helpers");
var logout_1 = __importDefault(require("./recover/logout"));
var me_1 = __importDefault(require("./recover/me"));
var protocols_1 = __importDefault(require("./recover/protocols"));
var quick_texts_1 = __importDefault(require("./recover/quick_texts"));
var sign_out_1 = __importDefault(require("./recover/sign_out"));
var subscription_levels_1 = __importDefault(require("./recover/subscription_levels"));
var supporting_documents_1 = __importDefault(require("./recover/supporting_documents"));
var terms_and_conditions_1 = __importDefault(require("./recover/terms_conditions/terms_and_conditions"));
var dashboard_1 = __importDefault(require("./recover/dashboard"));
/**
 *
 *
 * @export
 * @class Recover
 * @classdesc Returns an instance of the Recover API helper class.
 */
var Recover = /** @class */ (function () {
    /**
     *Creates an instance of Recover.
     * @param {{ endpoint: string }} config
     * @memberof Recover
     */
    function Recover(config) {
        var _this = this;
        /**
         *
         *
         * @memberof Recover
         * @returns { Actions } - Returns an instance of the Actions Library
         */
        this.actions = function () { return new actions_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { AppTexts }
         */
        this.appTexts = function () { return new app_texts_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Authorization }
         */
        this.authorization = function () { return new auth_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Companies }
         */
        this.companies = function () { return new companies_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Debts }
         */
        this.debts = function () { return new debts_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { DebtStatusCounts }
         */
        this.debt_status_counts = function () { return new debt_status_counts_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Debtors }
         */
        this.debtors = function () { return new debtors_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { DemandTemplates }
         */
        this.demand_templates = function () { return new demand_templates_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Demands }
         */
        this.demands = function () { return new demands_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Logout }
         */
        this.logout = function () { return new logout_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Me }
         */
        this.me = function () { return new me_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { Protocols }
         */
        this.protocols = function () { return new protocols_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { QuickTexts }
         */
        this.quick_texts = function () { return new quick_texts_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns {SignOut}
         */
        this.sign_out = function () { return new sign_out_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { SubscriptionLevels }
         */
        this.subscription_levels = function () { return new subscription_levels_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns { SupportingDocuments }
         */
        this.supporting_documents = function () { return new supporting_documents_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns {TermsAndConditions}
         */
        this.terms_and_conditions = function () { return new terms_and_conditions_1.default(_this); };
        /**
         *
         *
         * @memberof Recover
         * @returns {Dashboard}
         */
        this.dashboard = function () { return new dashboard_1.default(_this); };
        this.endpoint = config.endpoint;
        this.session_token = undefined;
    }
    /**
     *
     *
     * @template SuccessResponse
     * @description Global helper method for writing fetch requests with the Recover API
     * @param {string} endpoint
     * @param {('GET' | 'POST' | 'PUT' | 'DELETE')} [method='GET']
     * @param {(object | null)} [requestData=null]
     * @param {(IQueryParams | IQueryParamsWithAll | IQueryParamsWithDeleted | null)} params
     * @returns {Object}
     * @memberof Recover
     */
    Recover.prototype.request = function (endpoint, method, requestData, params) {
        if (method === void 0) { method = 'GET'; }
        if (requestData === void 0) { requestData = null; }
        return __awaiter(this, void 0, void 0, function () {
            var url, response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + this.endpoint + endpoint + (params != null ? helpers_1.convertParamsToQueryString(params) : '');
                        return [4 /*yield*/, fetch(url, __assign({ headers: {
                                    Authorization: this.session_token,
                                }, method: method }, (requestData != null ? { body: JSON.stringify(requestData) } : {})))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, response.ok
                                ? json
                                : Promise.reject(json)];
                }
            });
        });
    };
    return Recover;
}());
exports.default = Recover;
